import { Conversation, Participant } from "@chatscope/use-chat";
import BaseModel from "./BaseModel";
import ConversationParticipantModel from "./ConversationParticipantModel";
import moment, { Moment } from "moment-timezone";
import ApiDateParser from "../../helpers/parsers/apiDateParser";

export type ChatContact = {
  conversationTwillioId?: string;
  id: number;
  userType: string;
  name: string;
  badge: string;
  profilePictureUrl: string;
  unreadCount: number;
};
export default class ConversationModel extends BaseModel {
  twilioId: string;
  supervisorId: number | undefined;
  participants: ConversationParticipantModel[];
  lastMessageSentAt: Moment;
  private _unreadMessagesCount: number;

  constructor(arg: any) {
    super(arg);
    this.twilioId = arg.twilio_conversation_id;
    this.supervisorId = arg.supervisor_id;
    this.participants = ConversationParticipantModel.fromApiResponse(
      arg.participants
    );
    this._unreadMessagesCount = 0;
    this.lastMessageSentAt = !!arg.last_message_sent_at
      ? ApiDateParser.parse(arg.last_message_sent_at)
      : moment().add(-1, "year");
  }

  getReceiverParticipant(senderId: string): ConversationParticipantModel {
    return this.participants.find(
      (participant) =>
        participant.twillioId !== senderId &&
        !!participant.twillioId &&
        participant.twillioId !== ""
    )!;
  }

  hasReceiverParticipant(senderId: string): boolean {
    return !!this.getReceiverParticipant(senderId);
  }

  incrementUnreadCount(value: number) {
    this._unreadMessagesCount += value;
  }

  isValid(senderId: string): boolean {
    return this.hasReceiverParticipant(senderId) && !!this.twilioId;
  }

  get unreadMessagesCount(): number {
    return this._unreadMessagesCount;
  }

  get chatParticipants(): Participant[] {
    return (this.participants || []).map(
      (participant) => new Participant({ id: participant.twillioId! })
    );
  }

  createConversation(): Conversation<ConversationModel> {
    return new Conversation<ConversationModel>({
      id: this.twilioId,
      data: this,
      unreadCounter: this.unreadMessagesCount,
      participants: this.chatParticipants,
    });
  }

  static toChatContacts(
    conversations: ConversationModel[],
    currentUserTwillioId: string
  ): ChatContact[] {
    let contacts: ChatContact[] = [];
    conversations.forEach((conversation) => {
      const receiver =
        conversation.getReceiverParticipant(currentUserTwillioId);
      if (!!receiver) {
        contacts.push({
          conversationTwillioId: conversation.twilioId,
          id: receiver.id,
          userType: receiver.userType,
          name: receiver.displayName,
          badge: receiver.userType,
          profilePictureUrl: receiver.profilePictureUrl,
          unreadCount: conversation.unreadMessagesCount,
        });
      } else {
        console.error(
          "Receiver for conversation: ",
          conversation.twilioId,
          "Sender: ",
          currentUserTwillioId,
          "is not found "
        );
      }
    });
    return contacts;
  }
}
